import { render, staticRenderFns } from "./7.vue?vue&type=template&id=52280a64&scoped=true&"
var script = {}
import style0 from "./7.vue?vue&type=style&index=0&id=52280a64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52280a64",
  null
  
)

export default component.exports